<script>
import "./bootstrap-datepicker/bootstrap-datepicker.min.css"
import "./bootstrap-datepicker/bootstrap-datepicker.min.js"

export default {
  props: {
    value: [String],
    dateType: [String],
    config: Object,
    disabledYesterday: Boolean
  },
  mounted: function () {
    setTimeout(()=>{ this.init() },100);
  },
  methods:{
    init(){
      var option = {
        format: "dd-mm-yyyy",
        todayHighlight: true,
        autoclose: true,
        // startDate: '-0d'
        // startDate: "+0d"
      }
      if(this.disabledYesterday) Object.assign(option, { startDate: "+0d" })
      if(this.dateType=="dob") option = {
        orientation: "bottom",
        calendarWeeks: true,
        autoclose: true,
        todayHighlight: true,
        startView: 'decade',
        endDate: '-15y',
      }
      $(this.$el).datepicker(Object.assign(option,this.config||{})).change((e)=>{
        this.$emit('input', e.target.value)
        // if($(this.$el)) $(this.$el).valid()
      });
      if(this.value) $(this.$el).datepicker('update', this.value)
    }
  },
  watch: {
    value: function (v) {
      if(!v) return $(this.$el).datepicker("update", "");
      $(this.$el).datepicker("update", v)
    }
  }
}
</script>

<template>
  <input type="text" class="form-control" autocomplete="off">
</template>
